import KeyManagementListing from "./keyManagementListing"
import KeyManagementDetailScreen from "./keyMangementDetailScreen"
import KeyInvestigationScreen from "./keyInvestigationScreen"

const KeyManagement = {
    KeyManagementListing: KeyManagementListing,
    KeyManagementDetailScreen: KeyManagementDetailScreen,
    KeyInvestigationScreen: KeyInvestigationScreen,
}

export default KeyManagement